import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class BreedersGuard {
  private readonly env = inject(EnvironmentInjector) as Environment;
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.env.USE_POULTRY_SERVICE && this.env.BREEDERS_ENABLED) {
      return true;
    }
    this.router.navigate(['/flock']);
    return false;
  }
}
